import MissingManifest from './MissingManifest';

export default MissingManifest;
